import React from "react";
import { withTheme } from "styled-components";

import BaseSelect from "react-select";
import CreatableSelect from "react-select/creatable";

const defaultOptions = [
  { value: "chocolate", label: "Chocolate" },
  { value: "strawberry", label: "Strawberry" },
  { value: "vanilla", label: "Vanilla" },
];

const getCustomStyles = (
  theme,
  accentColor,
  bg,
  border,
  indicator,
  useHorizontalChips
) => {
  return {
    dropdownIndicator: () => {
      return {
        display: !indicator && "none",
      };
    },
    indicatorSeparator: () => {},
    option: (provided, state) => {
      return {
        ...provided,
        color: state.isSelected ? theme.colors[accentColor] : theme.colors.dark,
        textAlign: "left",
        backgroundColor: bg,
      };
    },
    control: (provided, state) => {
      const base = {
        ...provided,
        border: !border
          ? "none"
          : state.menuIsOpen || state.isFocused
          ? `1px solid ${theme.colors[accentColor]} !important`
          : `1px solid ${theme.colors.border} !important`,
        borderRadius: 10,
        padding: "0.25rem 1rem",
        width: "100%",
        minHeight: "45px",
        outline: "none",
        boxShadow: "none",
        textAlign: "left",
        backgroundColor: bg,
        alignItems: "center",
      };
      if (useHorizontalChips) {
        base.maxHeight = "45px";
        base.overflow = "hidden";
      }
      return base;
    },
    valueContainer: (provided) => {
      const base = {
        ...provided,
        padding: "0 8px",
        alignItems: "center",
      };
      if (!useHorizontalChips) {
        return base;
      }
      return {
        ...base,
        flexWrap: "nowrap",
        overflowX: "auto",
        overflowY: "hidden",
        flex: "1 1 0%",
        minWidth: 0,
      };
    },
    ...(useHorizontalChips
      ? {
          multiValue: (provided) => ({
            ...provided,
            flexShrink: 0,
          }),
          multiValueLabel: (provided) => ({
            ...provided,
            whiteSpace: "nowrap",
          }),
          multiValueRemove: (provided) => ({
            ...provided,
            flexShrink: 0,
          }),
          indicatorsContainer: (provided) => ({
            ...provided,
            flexShrink: 0,
          }),
          input: (provided) => ({
            ...provided,
            margin: 0,
            paddingTop: 0,
            paddingBottom: 0,
            minWidth: "12px",
          }),
        }
      : {}),
    singleValue: (provided) => ({
      ...provided,
      lineHeight: 1.5,
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 3000,
    }),
  };
};

const SelectStyled = ({
  theme,
  bg = "#fff",
  border = true,
  accentColor = "success",
  name = "item",
  indicator = true,
  options = defaultOptions,
  defaultValue,
  value,
  multiValueSingleRow = false,
  /** When true, renders react-select Creatable (same theme styles) so users can add values not in options */
  creatable = false,
  ...rest
}) => {
  const Cmp = creatable ? CreatableSelect : BaseSelect;
  const useHorizontalChips = !!rest.isMulti && multiValueSingleRow;
  // Build props object - only set defaultValue for uncontrolled components
  const selectProps = {
    styles: getCustomStyles(
      theme,
      accentColor,
      bg,
      border,
      indicator,
      useHorizontalChips
    ),
    name: name,
    options: options,
    ...rest
  };
  
  // If value is provided, it's a controlled component - don't use defaultValue
  if (value !== undefined) {
    selectProps.value = value;
  } else {
    // Uncontrolled component - use provided defaultValue or default to options[1]
    selectProps.defaultValue = defaultValue !== undefined ? defaultValue : options[1];
  }
  
  return (
    <Cmp {...selectProps} />
  );
};

export default withTheme(SelectStyled);
